import { LegacyRef, useEffect, useRef } from 'react';
import { EKA_EVENT } from '../../bridge/events/dispatch';
import React from 'react';
import { Appointment } from '../../api/fetchAppointmentById';

export type SlotModalEvents =
    | { type: 'CLOSE_SLOT_MODAL' }
    | { type: 'SLOT_MODAL_APT_BKD'; apt: Appointment };

function SlotModal({
    docId,
    ptId,
    clinicId,
    onClose,
    show,
    handleAppointmentBooking,
}: SelectSlotModalProps): JSX.Element {
    const ref = useRef<HTMLElement>(null);

    useEffect(() => {
        const shouldRegisterEvtHandler = show && (onClose || handleAppointmentBooking);
        if (!shouldRegisterEvtHandler) {
            return;
        }

        function onSlotModalEvent(evt: CustomEvent<SlotModalEvents>) {
            if (evt.detail.type === 'CLOSE_SLOT_MODAL') {
                onClose?.();
            } else if (evt.detail.type === 'SLOT_MODAL_APT_BKD') {
                handleAppointmentBooking?.(evt.detail.apt);
            }
        }
        ref.current?.addEventListener(EKA_EVENT, onSlotModalEvent as EventListener);

        return () => {
            ref.current?.removeEventListener(EKA_EVENT, onSlotModalEvent as EventListener);
        };
    }, [show]);

    if (!(docId && clinicId && ptId)) {
        return <></>;
    }

    return (
        <select-slot-modal
            ref={ref as LegacyRef<HTMLElement>}
            docid={docId}
            clinicid={clinicId}
            ptid={ptId}
            show={`${show}`}
        />
    );
}

export default SlotModal;

export type SelectSlotModalProps = {
    show: boolean;
    docId?: string;
    ptId?: string;
    clinicId?: string;
    onClose?: () => void;
    handleAppointmentBooking?: (apt: Appointment) => void;
};
